export enum MCTab {
  Onboarding = 'onboarding',
  Addons = 'addons',
}
